<template>
  <div v-if="detailData">
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="activity_watch" id="page0">
      <div class="activity_content warp">
        <h3>{{ detailData.title }}</h3>
        <div class="activity_content_head" ref="page0">
          <ul class="activity_content_date">
            <li>主办单位：{{ detailData.organization }}</li>
            <li>
              {{ detailData.position }}
              {{ parseTime(detailData.startdate, "{y}.{m}.{d}") }} -
              {{ parseTime(detailData.endtime, "{y}.{m}.{d}") }}
            </li>
          </ul>
          <user-operation
            v-if="detailData.title"
            class="user_operation"
            :shareObj="detailData"
            :hidecollection="disshow"
            @onCollection="goCollection()"
          ></user-operation>
        </div>
        <div class="activity_content_body">
          <div
            class="activity_content_bg"
            :style="{ backgroundImage: `url(${imgurl1})` }"
          ></div>
          <div
            class="activity_content_desc info_detail_desc"
            v-html="detailData.subject"
          ></div>
        </div>

        <div
          class="participating_experts warp"
          id="page0"
          ref="page0"
          v-if="expertsList.length > 0"
        >
          <h3 class="tips">参与导师</h3>
          <div class="exports_list">
            <div class="button-prev" @click="swiperChange('prev')">
              <svg
                t="1603440419638"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2695"
                width="32"
                height="32"
              >
                <path
                  d="M671.807 927.804l-415.632-415.804 415.632-415.803 63.445 63.616-352.017 352.209 352.017 352.102z"
                  p-id="2696"
                  fill="#8a8a8a"
                ></path>
              </svg>
            </div>
            <div v-swiper:mySwiper="swiperOption">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide box"
                  v-for="(item, index) in expertsList"
                  :key="index"
                >
                  <expert-card :info="item"></expert-card>
                </div>
              </div>
            </div>
            <div class="button-next" @click="swiperChange('next')">
              <svg
                t="1603440337801"
                class=""
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2017"
                width="32"
                height="32"
              >
                <path
                  d="M325.048 93.511l-60.030 59.435 357.181 359.631-360.184 356.603 59.522 59.93 420.207-416.043z"
                  p-id="2018"
                  fill="#8a8a8a"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="active_side">
        <ul
          class="active_wber"
          @click="navChange(index)"
          :key="index"
          v-for="(item, index) in activeSide"
          :class="current == index ? 'active_wber_li' : ''"
        >
          <li>{{ item }}</li>
        </ul>
      </div>
    </div>

    <div class="activity_text" id="page1" ref="page1">
      <div class="activity_text_in warp">
        <img :src="imgurl2" alt="" />
        <div class="activity_text_desc">
          <h3>
            {{ detailData.contentname ? detailData.contentname : "活动内容" }}
          </h3>
          <div
            class="info_detail_desc"
            v-html="keepTextStyle(detailData.content)"
          ></div>
        </div>
      </div>
    </div>
    <div
      class="participation_activities warp"
      id="page2"
      ref="page2"
      v-if="detailData.object"
    >
      <h3 class="tips">
        {{ detailData.objectname ? detailData.objectname : "参与活动" }}
      </h3>
      <div class="info_detail_desc" v-html="detailData.object"></div>
    </div>
    <!--活动报名-->
    <div class="active_portive" id="page3" ref="page3">
      <button class="active_but" @click.prevent="onEnroll()">立即报名</button>
    </div>
    <!--弹框-->
    <div class="active_dialog">
      <el-dialog
        title="活动报名"
        :visible.sync="dialogFormVisible"
        @close="dialogClose"
      >
        <!-- <div class="exports_sign"> -->
        <!-- <h3 class="tips">活动报名</h3> -->
        <el-form
          ref="form"
          :model="form"
          label-width="100px"
          :rules="rules"
          :label-position="labelPosition"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="联系人 :"
                prop="contacts"
                class="item"
                style="width: 90%"
              >
                <el-input v-model="form.contacts"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="电话 :"
                prop="contactnumber"
                class="item"
                style="width: 90%"
              >
                <el-input
                  v-model="form.contactnumber"
                  maxlength="11"
                  oninput="value=value.replace(/[^\d]/g,'')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="公司名称 :"
                prop="company"
                class="item"
                style="width: 90%"
              >
                <el-input v-model="form.company"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="人数 :"
                prop="total"
                class="item"
                style="width: 90%"
              >
                <el-input
                  oninput="value=value.replace(/[^\d]/g,'')"
                  v-model="form.total"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="出发地 :"
                prop="comefrom"
                class="item"
                style="width: 90%"
              >
                <el-input v-model="form.comefrom"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="是否需要停车:"
                class="item"
                label-width="110px"
                prop="parking"
              >
                <el-radio-group v-model="form.parking">
                  <el-radio :label="0">需要</el-radio>
                  <el-radio :label="1">不需要</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="是否需要住宿:"
                class="item"
                label-width="110px"
                prop="accommodation"
              >
                <el-radio-group v-model="form.accommodation">
                  <el-radio :label="0">需要</el-radio>
                  <el-radio :label="1">不需要</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="item" style="text-align: right">
                <el-button @click="formSubmit">立即报名</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- </div> -->
      </el-dialog>
    </div>
    <!--弹框登录-->
    <loginDialog :dialogVisible.sync="dialogVisibles"></loginDialog>
  </div>
</template>
<script>
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import userOperation from "../../common/userOperation";
import { activityJiCaiInfo } from "@/api/coment";
import { activityJiCaiReg } from "@/api/information";
import { parseTime, toLogin, phoneNumValidate } from "@/utils";
import { getToken } from "@/utils/auth";
import { addCollection } from "@/api/coment";
import expertCard from "../../components/expertCard";
import loginDialog from "../../components/loginDialog";
export default {
  components: { commBanner, titleHead, userOperation, expertCard, loginDialog },
  data() {
    const validatePhone = (rule, value, callback) => {
      const regMobile = /^\d{11}$/;
      if (regMobile.test(value)) {
        return callback();
      }
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else if (!phoneNumValidate(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };

    return {
      headTitle: "活动详情",
      disshow: true,
      imgurl1: "",
      imgurl2: "",
      obj: {
        title: "活动详情",
        isShow: false,
        isActive: false,
        roleType: "",
        personalType: 7,
        companytype: "",
      },
      swiperOption: {
        slidesPerView: 4, // 显示的数量
        spaceBetween: 30, // 每张的间距
        slidesPerGroup: 1,
      },
      current: 0,
      form: {
        contacts: "",
        contactnumber: "",
        company: "",
        total: "",
        comefrom: "",
        parking: 0,
        accommodation: 0,
        parliamentid: "",
      },
      rules: {
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        contactnumber: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        total: [
          { required: true, message: "请输入报名人数", trigger: "blur" },
          // { type: 'number', message: '请填入正确的人数', trigger: "blur" }
        ],
        comefrom: [
          { required: true, message: "请输入出发地", trigger: "blur" },
        ],
        parking: [
          { required: true, message: "请选择是否需要停车", trigger: "change" },
        ],
        accommodation: [
          { required: true, message: "请选择是否需要住宿", trigger: "change" },
        ],
      },
      activeSide: ["活动详情", "参与导师", "活动内容", "参与活动", "活动报名"],
      labelPosition: "left",
      id: "",
      detailData: "",
      expertsList: [],
      dialogFormVisible: false,
      listBoxState: true,
      dialogVisibles: false,
      type: "",
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.activityJiCaiInfo();
    if (this.$store.state.user.userInfo != null) {
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
    }
  },
  mounted() {
    let timeId;
    window.addEventListener(
      "scroll",
      () => {
        // 页面滚动停止100毫秒后才会执行下面的函数。
        clearTimeout(timeId);
        timeId = setTimeout(() => {
          this.scrollToTop();
        }, 100);
      },
      true
    );
  },
  // beforeDestroy(){
  //   window.removeEventListener('scroll',this.scrollToTop())
  // },
  methods: {
    parseTime() {
      return parseTime(...arguments);
    },
    //获取活动详情
    activityJiCaiInfo() {
      activityJiCaiInfo({
        id: this.id,
      }).then((res) => {
        if (res.code == 0) {
          console.log(res)
          this.detailData = res.data;
          this.getMate(res.data);
          this.type = res.data.type;
          this.activeSide[2] = this.detailData.contentname
            ? this.detailData.contentname
            : "活动内容";
          this.activeSide[3] = this.detailData.objectname
            ? this.detailData.objectname
            : "参与活动";
          if (!this.detailData.content) {
            this.activeSide.splice(2, 1);
          }
          if (!this.detailData.object) {
            this.activeSide.splice(3, 1);
          }
          if (res.experts.length == 0) {
            this.activeSide.splice(1, 1);
          }
          if (
            null != this.detailData.cover &&
            this.detailData.cover.split(",").length > 2
          ) {
            this.imgurl1 = this.detailData.cover.split(",")[1];
            this.imgurl2 = this.detailData.cover.split(",")[2];
          } else {
            this.imgurl1 = this.detailData.cover.split(",")[0];
            this.imgurl2 = this.detailData.cover.split(",")[0];
          }
          this.expertsList = res.experts;
        }
      });
    },
    //切换轮播图
    swiperChange(type) {
      switch (type) {
        case "prev":
          this.mySwiper.slidePrev();
          break;

        default:
          this.mySwiper.slideNext();
          break;
      }
    },
    //报名
    onEnroll() {
      if (getToken() == undefined) {
        this.dialogVisibles = !this.dialogVisibles;
      } else {
        this.dialogFormVisible = true;
      }
    },
    resetFrom() {
      this.$refs.form.resetFields();
      this.$refs.form.clearValidate();
    },
    formSubmit() {
      this.$refs.form
        .validate()
        .then((valid) => {
          this.form.parliamentid = this.id;
          activityJiCaiReg(this.form).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "报名成功",
                type: "success",
                duration: 3000,
              });
            } else {
              this.$message.error(res.msg);
            }
            this.dialogFormVisible = false;
            this.resetFrom();
          });
        })
        .catch((err) => {});
    },
    dialogClose() {
      this.resetFrom();
    },
    //活动收藏
    goCollection() {
      if (this.$store.state.user.userInfo == null) {
        this.$message({
          message: "登录后，才能收藏",
          type: "info",
        });
      } else {
        addCollection({
          goodsId: this.id,
          goodsType: 6,
        })
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "收藏成功！",
                type: "success",
              });
            }
          })
          .catch((err) => {});
      }
    },

    navChange(index) {
      this.current = index;
      this.$nextTick(() => {
        this.$el.querySelector(`#page${index}`).scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "start", // 上边框与视窗顶部平齐。默认值
        });
        this.listBoxState = false;
      });

      let timeId;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 200);
    },
    // 监听页面元素滚动，改变导航栏选中
    scrollToTop() {
      // 获取视窗高度
      var domHight = document.body.offsetHeight;
      // dom滚动位置
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (this.listBoxState) {
        //作用是点击导航栏时，延迟这里执行。
        this.activeSide.map((v, i) => {
          // 获取监听元素距离视窗顶部距离
          var offsetTop = document.getElementById(`page${i}`).offsetTop;
          // 获取监听元素本身高度
          var scrollHeight = document.getElementById(`page${i}`).scrollHeight;
          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollHeight) {
            // 导航栏背景色选中
            this.navgatorIndex = i;
          }
        });
      }
    },
    keepTextStyle(val) {
      return (val + "").replace(/(<br[^>]*>|\s*)/g, "");
    },
    getMate(data) {
      var metas = document.getElementsByTagName("meta");
      metas[0].name = "keyword";
      metas[0].content = data.seokeywords;
      metas[1].name = "description";
      metas[1].content = data.seodescription;
      document.getElementsByTagName("title")[0].innerText =
        data.title + "_智污邦环保服务平台";
    },
  },
  watch: {
    type(val, oldval) {
      if (val == 1) {
        this.$router.push({
          path: "/exhibition_detail",
          query: { id: this.id },
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
/deep/ .el-form-item__label {
  color: #ffffff;
}
/deep/ .el-radio__label {
  color: #ffffff;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #ffffff !important;
}
.fsb {
  display: flex;
  justify-content: left;
}

.active_side {
  position: fixed;
  top: 50%;
  right: 0.5%;
  background: #ffffff;
  transform: translate(0%, -25%);
  z-index: 99999;
  width: 125px;
  // height:190px;
}
.active_side:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
}
.active_wber li {
  height: 41px;
  text-align: center;
  line-height: 41px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.active_wber li:hover {
  cursor: pointer;
}
.active_wber_li {
  background: #ff7302;
  color: #ffffff !important;
}

.tips {
  margin: 30px 0 20px !important;
  text-align: center;
  position: relative;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  padding-left: 10px;
  margin-bottom: 10px;
  &::before {
    position: absolute;
    left: 44%;
    bottom: 4px;
    display: inline-block;
    content: "";
    width: 5px;
    height: 23px;
    background: #ff7302;
  }
}

.activity_content {
  h3 {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
  .activity_content_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    .activity_content_date {
      flex: 6;
      display: flex;
      li {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin-right: 20px;
      }
    }
    .user_operation {
      flex: 4;
      margin-top: 0;
    }
  }
  .activity_content_body {
    display: flex;
    .activity_content_bg {
      position: relative;
      width: 25%;
      height: 466px;
      background: url("../../assets/images/advertisement_position.jpg")
        no-repeat center/100%;
      background-position: center;
      background-size: cover;
      span {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: inline-block;
        width: 48px;
        height: 255px;
        font-size: 48px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .activity_content_desc {
      width: 75%;
      margin-left: 20px;
      line-height: 24px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      p {
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }
      ul {
        margin-top: 20px;
        li {
          margin-bottom: 10px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          &:last-of-type {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
.participating_experts {
  margin-top: 59px;
  border-top: 1px solid #eeeeee;
  width: 100%;
  h3 {
    margin: 35px 0;
    text-align: center;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }
  .exports_list {
    display: flex;
    align-items: center;
    .button-prev,
    .button-next {
      margin-top: 100px;
      cursor: pointer;
    }
  }
}
.activity_text {
  width: 100%;
  background: rgba(232, 232, 232, 0.5);
  .activity_text_in {
    display: flex;
    align-items: center;
    padding: 40px 0;
    margin: 50px auto;
    img {
      width: 25%;
      height: 185px;
      margin-right: 25px;
    }
    .activity_text_desc {
      width: 75%;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 23px;
      h3 {
        position: relative;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        padding-left: 15px;
        margin-bottom: 10px;
        &::before {
          position: absolute;
          left: 0;
          bottom: 0px;
          display: inline-block;
          content: "";
          width: 5px;
          height: 23px;
          background: #ff7302;
        }
      }
      p {
        line-height: 2;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
.participation_activities {
  margin-bottom: 60px;
  h3 {
    margin: 35px 0 25px !important;
  }
  div {
    line-height: 24px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  .exports_sign {
    padding: 20px 40px;
    background: url("../../assets/images/activity_bg.png") no-repeat center/100%;
    h3 {
      color: #ffffff;
      &::before {
        background: #ffffff;
      }
    }
  }
}
.swiper-container {
  width: 100%;
}
.swiper-wrapper {
  height: 400px;
  position: relative;
}

/deep/.el-dialog {
  background: url("../../assets/images/active_far.png") no-repeat;
}
/**弹框样式**/
/deep/.el-dialog__header {
  display: flex;
  justify-content: center;
}
/deep/.el-dialog__title {
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
  color: #fff;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #50b035;
  background: #50b035;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #333333;
}
/deep/.el-button {
  // background: #3bbb35;
  color: #ffffff;
  border: 1px solid #ffffff;
  background: transparent;
  border-radius: 3px;
  margin-right: 46px;
}
.active_but {
  margin-top: 20px;
  width: 100px;
  height: 35px;
  text-align: center;
  line-height: 24px;
  background: #ffffff;
  font-size: 14px;
  font-family: Microsoft YaHei;
  border: 1px solid #eeeeee;
}
.active_but:hover {
  background: #ff7302;
}

.el-form-item__error {
    color: #000000;
}
.active_portive {
  width: 71%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/view/other/jicai_activity_detail.vue